import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons'

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'cotas';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-cotas-container" ref={nodeRef}>
        <Row className="login-cotas-header">
          <Col>
            <h5>Inicio de Sesión</h5>
          </Col>
        </Row>
        <Row className="login-cotas-body">
          <Col>
            <Form onSubmit={(event) => onSubmit(event)}>
              <Container fluid={true} className="email-cotas">
                <Row className="container-input-cotas">
                  <Col sm="2" xs="2" md="2" className="cotas-icon-lbl my-auto ">
                    <FontAwesomeIcon icon={faUser} color="rgba(0,0,0,0.2)" />
                  </Col>
                  <Col sm="10" xs="10" md="10" className="cotas-input">
                    <Input
                      className="user-input-cotas"
                      disabled={onLogin}
                      placeholder={translate("PlaceholderUserName")}
                      required={true}
                      tabIndex={1}
                      type="text"
                      autoCorrect="off"
                      autoCapitalize="none"
                      id="username"
                      onChange={e => setUsername(e.target.value)}
                    />
                  </Col>
                </Row>
              </Container>
              <Container fluid={true} className="pass-cotas">
                <Row className="container-input-cotas">
                  <Col sm="2" xs="2" md="2" className="cotas-icon-lbl my-auto ">
                    <FontAwesomeIcon icon={faLock} color="rgba(0,0,0,0.2)" />
                  </Col>
                  <Col sm="10" xs="10" md="10" className="cotas-input">
                    <Input
                      className="pass-input-cotas"
                      required={true}
                      disabled={onLogin}
                      placeholder={translate("PlaceholderPassword")}
                      tabIndex={1}
                      type="password"
                      autoCorrect="off"
                      autoCapitalize="none"
                      id="password"
                      onChange={e => setPassword(e.target.value)}
                    />
                  </Col>
                </Row>
              </Container>
              {!onLogin ? (
                <div className="container-button">
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-cotas"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                </div>
              ) : (
                <div className="container-progress-bar" style={{ marginTop: 20 }}>
                  <Progress animated color="danger" value={100} className="cotas-progress-bar" />
                </div>
              )}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            </Form>
            <p className="recover-pass-cotas">
              <a href="https://play.cotas.com/Home/SolicitudRecuperar" target="_blank" rel="noopener noreferrer">¿Olvidó su contraseña?</a>
            </p>
            {
              checkDeviceIOS() ? '' : <p className="register-pass-cotas">Si aún no estás registrado, dirígete a
                <a href="http://play.cotas.com/Home/RegistroPlay" target="_blank" rel="noopener noreferrer"> Cotas Play</a>
              </p>
            }
          </Col>
        </Row>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true });
